<!--   平台运维-服务器管理-添加或修改服务器（操作服务器） -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea OperateServer">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <el-form
          class="serverForm"
          ref="serverForm"
          :model="serverForm"
          label-width="120px">
          <p class="title">服务器基本信息</p>
          <el-form-item label="服务器组" prop="server_category_id" :rules="{ required: true, message: '请选择服务组', trigger: 'change' }">
            <el-select class="serverGroupSelect" v-model="serverForm.server_category_id">
              <el-option :label="item.name" :value="item.category_id"
                v-for="(item, index) in serverGroupList"
                :key="index"></el-option>
            </el-select>
            <el-checkbox class="mainServer" v-model="serverForm.server_is_admin">设为主服务器</el-checkbox>
          </el-form-item>
          <el-form-item label="服务器名称：" prop="server_name" :rules="{ required: true, message: '请输入服务器名称', trigger: 'blur' }">
            <el-input v-model="serverForm.server_name"></el-input>
          </el-form-item>
          <el-form-item label="服务器地址：" prop="server_ip" :rules="{ required: true, message: '请输入服务器地址', trigger: 'blur' }">
            <el-input v-model="serverForm.server_ip"></el-input>
          </el-form-item>
          <el-form-item label="4.0业务地址：" prop="api_host_v4" :rules="{ required: true, message: '请输入4.0业务地址', trigger: 'blur' }">
            <el-input v-model="serverForm.api_host_v4"></el-input>
          </el-form-item>
          <el-form-item label="4.0s业务地址：" prop="api_host_v4s" :rules="{ required: true, message: '请输入4.0s业务地址', trigger: 'blur' }">
            <el-input v-model="serverForm.api_host_v4s"></el-input>
          </el-form-item>
          <el-form-item label="用途：" prop="server_use" :rules="{ required: true, message: '请输入用途', trigger: 'blur' }">
            <el-input type="textarea" rows="3" v-model="serverForm.server_use"></el-input>
          </el-form-item>
          <el-form-item label="配置：" prop="server_config" :rules="{ required: true, message: '请输入配置', trigger: 'blur' }">
            <el-input type="textarea" rows="3" v-model="serverForm.server_config"></el-input>
          </el-form-item>
          
          <!-- 添加服务器信息显示 -->
          <div class="serverFeeInfo" v-if="type === '添加服务器'">
            <p class="title">服务器费用信息</p>
            <el-form-item class=" cost" label="费用" prop="server_cost" :rules="{ required: true, message: '请输入费用', trigger: 'blur' }">
              <el-select class="costSelect" v-model="serverForm.server_is_yorm">
                <el-option label="月" value="2"></el-option>
                <el-option label="年" value="1"></el-option>
              </el-select>
              <el-input class="costInput" type="text" v-model="serverForm.server_cost"></el-input> &nbsp;&nbsp;元
            </el-form-item>
            <el-form-item label="使用期限" prop="server_date" :rules="{ required: true, message: '请选择使用期限', trigger: 'change' }">
              <el-date-picker
                class="dataPicker"
                v-model="serverForm.server_date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </div>

          <el-form-item>
            <el-button class="confirmBtn" type="primary" @click="updateServer">确 认</el-button>
            <el-button @click="back">取 消</el-button>
          </el-form-item>
        </el-form>
      </div>
  </div>
</template>


<script>
  import BreadCrumb from "../../../Layout/BreadCrumb.vue"
  import { storage, getBreadCrumb, showToast } from "../../../../../static/js/utility/utility.js"
  import { getNowDate } from "../../../../../static/js/utility/date.js"
  import { maintainApi } from "../../../../../static/js/api.js"
  let vm

  export default {
    name: 'OperateServer',
    components: {
      BreadCrumb
    }, 
    data() {
      return {
        // 当前操作
        type: '',
        // 服务器表单数据
        serverForm: {
          server_category_id: '',
          server_is_admin: false,
          server_name: '',
          server_ip: '',
          api_host_v4: '',
          api_host_v4s: '',
          server_use: '',
          server_config: '',
          server_is_yorm: '2',
          server_cost: '',
          server_date: ''
        },
        // 服务器组列表
        serverGroupList: []
      }
    },
    created () {
      vm = this
      vm.getServerCategoryList()
    },
    mounted(){
      let length = getBreadCrumb().length
      this.type = getBreadCrumb()[length-1].function_name
      // console.log('getBreadCrumb()[length-1].function_tab', getBreadCrumb()[length-1].function_name)

      // 当为修改服务器时,获取服务器信息
      if (vm.$route.query.server_id) {
        vm.getServerInfo()
      } else if( vm.$route.query.server_category_id ) {
        vm.serverForm.server_category_id = vm.$route.query.server_category_id
      }
    },
    destroyed() {},
    methods: {
      // 获取单台服务器信息
      async getServerInfo () {
        let data = { server_id: vm.$route.query.server_id }
        let res = await maintainApi.getServerInfo(data)
        if (res.meta.code === 200) {
          vm.serverForm = res.data
          vm.serverForm.server_is_admin = vm.serverForm.server_is_admin == '1' ? true : false
          vm.serverForm.server_date = [vm.serverForm.server_begin_date, vm.serverForm.server_end_date]
        } else {
          showToast(res.meta.message)
        }
      },
      // 获取服务器组列表
      async getServerCategoryList () {
        let res = await maintainApi.getServerCategoryList()
        if (res.meta.code === 200) {
          vm.serverGroupList = res.data
        } else {
          showToast(res.meta.message)
        }
      },
      //  更新（添加/修改）服务器
      updateServer: async function () {
        vm.$refs['serverForm'].validate(async (valid) => {
          if (valid) {
            let server_date = vm.serverForm.server_date 
            let data = {
              server_category_id: vm.serverForm.server_category_id,
              server_is_admin: vm.serverForm.server_is_admin ? '1' : '0' ,
              server_name: vm.serverForm.server_name,
              server_ip: vm.serverForm.server_ip,
              api_host_v4: vm.serverForm.api_host_v4,
              api_host_v4s: vm.serverForm.api_host_v4s,
              server_use: vm.serverForm.server_use,
              server_config: vm.serverForm.server_config,
            }
            if (!vm.$route.query.server_id) {
              data.server_is_yorm = vm.serverForm.server_is_yorm
              data.server_cost = vm.serverForm.server_cost
              data.server_begin_date = getNowDate(server_date[0])
              data.server_end_date = getNowDate(server_date[1])
            } else {
              data.server_id = vm.serverForm.server_id
            }

            let res = await maintainApi.updateServer(data)
            if (res.meta.code === 200) {
              showToast(vm.type === '添加服务器' ? '添加成功' : '修改成功')
              setTimeout(function() {
                vm.back()
              }, 1000)
            } else {
              showToast(res.meta.message)
            }
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      // 返回上一页
      back: function () {
        this.$router.go(-1)
      }
    },
    watch: {
    }
  }
</script>

<style lang="scss" scoped>
.serverForm {
  width: 520px;
  display: flex;
  flex-direction: column;
  .title {
    font-size: 18px;
    margin-bottom: 20px;
  }
  .serverGroupSelect,
  .mainServer {
    display: block;
  }
  .mainServer {
    margin-top: 5px;
  }
  .el-form-item.cost .costSelect,
  .el-form-item.cost .costInput {
    float: left;
    width: 178px;
  }
  .el-form-item.cost .costSelect {
    margin-right: 20px;
  }
  .serverFeeInfo {
    margin-top: 20px;
  }
  // 时间选择器
  .dataPicker {
    width: 100%;
  }
  .confirmBtn {
    margin-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/Maintain/ServerManage/OperateServer.vue